import React from "react";
import { Link, Redirect } from "react-router-dom";
import { Modal, Icon, Header, Segment, ModalProps, Placeholder, Message } from "semantic-ui-react";
import ICategory from "../../interfaces/ICategory";
import { useFormTypeListByCategoryId } from "../../store/selectors/formSelectors";
import { isLoaded, isLoadErrored } from "../../../../sg-core";
import { useTranslation } from "react-i18next";
import { makeNewObservationPageHref } from "../../utils/havainnot.helper";

interface IFormListModal {
    category: ICategory;
}

const FormListModal: React.FC<IFormListModal & ModalProps> = ({ category, ...modalProps }) => {
    const { t } = useTranslation();
    const formTypes = useFormTypeListByCategoryId(category.id)
    const formListHeader = t("Valitse lomake")


    if (isLoaded(formTypes) && formTypes.data.length === 1) {
        const to = makeNewObservationPageHref(
            formTypes.data[0].formDefinition,
            formTypes.data[0].guid
        );


        if (to) {
            return (
                <Redirect
                    push
                    to={to}
                />
            )
        }
    }

    return (
        <Modal {...modalProps}>
            <Modal.Header>
                {category.icon ? <Icon name={category.icon} /> : null}
                {category.name}
            </Modal.Header>
            <Modal.Content>
                <Header.Subheader as="h4" className="ui">  {formListHeader} </Header.Subheader>
                {isLoaded(formTypes) ? (
                    <Segment.Group>
                        {formTypes.data.map((formType) => (
                            <Segment
                                key={formType.id}
                                as={Link}
                                to={makeNewObservationPageHref(formType.formDefinition, formType.guid)}
                                style={{ display: 'block' }}
                            >
                                {formType.name}
                            </Segment>
                        ))
                        }
                    </Segment.Group>
                ) : isLoadErrored(formTypes) ? (
                    <Message content={t("Hakeminen epäonnistui!")} negative />
                ) : (
                    <Placeholder>
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder>
                )}

            </Modal.Content>
        </Modal >
    );
};


export default FormListModal;
